<template>
    <div class="title">
        <el-form :model="titleData" :inline="true" label-width="70px" class="search-form">
            <span class="font">新客</span>
            <div>
                <el-form-item label="购买日期">
                    <span>{{titleData.purchaseTime}}</span>
                </el-form-item>
                <el-form-item label="人数" label-width="50px">
                    <span>{{titleData.client}}</span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.project}}</span>
                </el-form-item>
                <el-form-item label="营收" label-width="80px">
                    <span>{{titleData.projectAmt}}</span>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="划扣日期">
                    <span>{{titleData.musTime}}</span>
                </el-form-item>
                <el-form-item label="人数" label-width="50px">
                    <span>{{titleData.musClient}} </span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.musProject}}</span>
                </el-form-item>
                <el-form-item label="划扣金额" label-width="80px">
                    <span>{{titleData.musAmt}}</span>
                </el-form-item>
            </div>
        </el-form>
        <el-form :model="titleData" :inline="true" label-width="70px" class="search-form">
            <span class="old font">老客</span>
            <div>
                <el-form-item label="人数">
                    <span>{{titleData.clientOld}}</span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.projectOld}}</span>
                </el-form-item>
                <el-form-item label="营收" label-width="80px">
                    <span>{{titleData.projectAmtOld}}</span>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="人数">
                    <span>{{titleData.musClientOld}}</span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.musProjectOld}}</span>
                </el-form-item>
                <el-form-item label="划扣金额" label-width="80px">
                    <span>{{titleData.musAmtOld}}</span>
                </el-form-item>
            </div>
        </el-form>
        <el-form :model="titleData" :inline="true" label-width="70px" class="search-form">
            <span class="old font">总计</span>
            <div>
                <el-form-item label="人数">
                    <span>{{titleData.client+titleData.clientOld}}</span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.project+titleData.projectOld}}</span>
                </el-form-item>
                <el-form-item label="营收" label-width="80px">
                    <span>{{titleData.bb}}</span>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="人数">
                    <span>{{titleData.musClient+titleData.musClientOld}}</span>
                </el-form-item>
                <el-form-item label="项目数" label-width="70px">
                    <span>{{titleData.musProject+titleData.musProjectOld}}</span>
                </el-form-item>
                <el-form-item label="划扣金额" label-width="80px">
                    <span>{{titleData.aa}}</span>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script>
export default {
    props: ['titleData'],
    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style scoped>
.title {
  display: flex;
}
.title >>> .el-form-item {
  margin: 0px !important;
}
.title >>> .el-form--inline .el-form-item__label {
  height: 20px !important;
  line-height: 20px;
}
.el-form-item__label {
  padding: 0 5px 0 0;
  box-sizing: border-box;
}
.old {
  margin-left: 30px;
}
.font {
  font-size: 14px;
  color: #606266;
}
</style>

